import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnderpants = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.5641 6.5H2.73568C2.40095 6.5 2.1499 6.75105 2.1499 7.08577V10.182C2.1499 12.023 3.32145 13.0272 5.66455 13.2782C8.00764 13.4456 9.01183 14.6172 9.26287 17.3787C9.26287 17.7134 9.5976 17.9644 9.84865 17.9644H14.4512C14.7859 17.9644 15.0369 17.7134 15.0369 17.3787C15.3717 14.6172 16.3758 13.4456 18.6353 13.2782C20.9784 13.1109 22.1499 12.1067 22.1499 10.182V7.08577C22.1499 6.75105 21.8989 6.5 21.5641 6.5ZM20.9784 10.182C20.9784 10.7678 20.9784 11.772 18.6353 12.023C15.8738 12.2741 14.3675 13.6967 13.9491 16.7092H10.4344C10.016 13.6967 8.50974 12.2741 5.74823 12.023C3.40513 11.8556 3.40513 10.8515 3.40513 10.182V7.75523H20.9784V10.182Z",
		fill: "currentColor"
	})
});
export default SvgUnderpants;
